export default __webpack_public_path__ + "fa92a48bc590453e27c3efd6f33040b9.svg";